import React from 'react'
import '../styles/RoomSeoSection.css'
import TerpecaLogo from '../images/Awards/terpeca-logo.avif'
import EscapeGameAwardsLogo from '../images/Awards/logo-ega.png'
import TripadvisorLogo from '../images/Awards/tripadvisor-choice.jpg'
import MortyLogo from '../images/Awards/bestofmorty.png'
import LiteYouTubeEmbed from './LiteYouTubeEmbed'
import ThemeCustomerReviews from './ThemeCustomerReviews'

const customerReviewThemeByRoom = {
  lostAsylum: 'la',
  vbn: 'vbn',
  abattoir: 'abattoir',
  yakuza: 'yakuza',
  tombeau: 'tombeau'
}

const getYouTubeEmbedId = (url) => {
  const embedMarker = '/embed/'
  const embedIndex = url.indexOf(embedMarker)

  if (embedIndex === -1) {
    return url
  }

  return url.slice(embedIndex + embedMarker.length).split('?')[0]
}

const getAwardLogo = (title) => {
  const normalizedTitle = title.toLowerCase()

  if (normalizedTitle.indexOf('terpeca') !== -1) {
    return { className: 'room-seo-award-logo--terpeca', label: 'TERPECA', image: TerpecaLogo }
  }

  if (normalizedTitle.indexOf('morty') !== -1) {
    return { className: 'room-seo-award-logo--morty', label: 'Best of Morty', image: MortyLogo }
  }

  if (
    normalizedTitle.indexOf('tripadvisor') !== -1 ||
    normalizedTitle.indexOf('travelers') !== -1 ||
    normalizedTitle.indexOf('travellers') !== -1
  ) {
    return {
      className: 'room-seo-award-logo--tripadvisor',
      label: "Tripadvisor Travelers' Choice",
      image: TripadvisorLogo
    }
  }

  if (
    normalizedTitle.indexOf('escape awards') !== -1 ||
    normalizedTitle.indexOf('escape game awards') !== -1 ||
    normalizedTitle.indexOf('award du meilleur') !== -1 ||
    normalizedTitle.indexOf('awards du meilleur') !== -1
  ) {
    return { className: 'room-seo-award-logo--escape-awards', label: 'Escape Game Awards', image: EscapeGameAwardsLogo }
  }

  return null
}

const data = {
  lostAsylum: {
    notice: [
      "L'âge minimum recommandé pour participer à une session chez One Hour est de 14 ans. Déconseillé aux personnes épileptiques.",
      "Paiement partagé disponible pour permettre à chaque joueur de régler sa part."
    ],
    whyTitle: 'Pourquoi choisir Lost Asylum ?',
    why: [
      ['Asile psychiatrique abandonné ultra immersif'],
      ['Gameplay évolutif adapté aux débutants et experts'],
      ['Mécanismes sans cadenas'],
      ["Présence d'acteurs"],
      ['Sélection TERPECA à plusieurs reprises'],
      ['Jouable de 2 à 5 joueurs'],
      ["Plus de 10 ans d'améliorations continues"]
    ],
    forTitle: "À qui s'adresse cette salle ?",
    forIntro: 'Lost Asylum est idéal si :',
    for: [
      "Vous aimez les films d'horreur",
      'Vous recherchez un escape game immersif',
      'Vous voulez avoir peur sans faire un parcours hanté',
      'Vous êtes un groupe de 2 à 5 joueurs',
      'Vous cherchez un premier escape game horreur à Paris'
    ],
    awardsTitle: 'Récompenses et reconnaissances',
    awardsIntro: "Lost Asylum a été sélectionné parmi les meilleurs escape games du monde aux TERPECA, une élection internationale qui distingue chaque année les meilleures salles.",
    awards: [
      ['Sélection TERPECA', '2019, 2020, 2021, 2022 et 2024'],
      ["Tripadvisor Travelers' Choice", '2025'],
      ['Awards du meilleur Game Master', "Meilleur Game Master Escape Game en 2016 et 2017 grâce à l'expérience proposée autour de Lost Asylum."],
      ['Notes de la communauté', <span><a href="https://lemeilleurescapegame.fr/One_Hour_Paris/lost-asylum" target="_blank" rel="noopener noreferrer">19,5/20 sur Le Meilleur Escape Game</a> et <a href="https://www.escapegame.fr/paris/one-hour/lost-asylum/" target="_blank" rel="noopener noreferrer">5/5, 94% de la communauté sur EscapeGame.fr</a>.</span>]
    ],
    splitTitle: 'Un escape game en constante évolution',
    splitText: [
      "Lost Asylum, pionnier de l'escape game horreur à Paris et premier escape game de One Hour, est sorti en 2015.",
      "Afin de proposer une expérience à la hauteur des escape games nouvelle génération, Lost Asylum a subi de nombreuses évolutions : gameplay, mécanismes sans cadenas, décors et rythme de jeu.",
      "L'ensemble de l'aventure a été entièrement repensé en 2021, puis continue d'être amélioré au quotidien par notre équipe."
    ],
    faqTitle: 'FAQ Lost Asylum',
    faq: [
      ['Lost Asylum fait-il vraiment peur ?', "Lost Asylum est un escape game d'épouvante qui mélange énigmes, tension et immersion dans un asile psychiatrique abandonné."],
      ['Peut-on jouer à Lost Asylum à 2 joueurs ?', 'Oui, la salle est conçue pour accueillir de 2 à 5 joueurs.'],
      ['Y a-t-il des acteurs ?', 'Oui, certains éléments du jeu peuvent surprendre ou effrayer les participants.'],
      ['Est-ce adapté à une première expérience ?', 'Oui, grâce au gameplay évolutif.'],
      ["Combien de temps dure l'expérience ?", "Comptez environ 1h30 entre l'expérience, le débrief et la photo souvenir."]
    ],
    geoTitle: 'Lost Asylum : un escape game horreur incontournable à Paris',
    geo: [
      "Situé dans le 11e arrondissement de Paris, Lost Asylum est un escape game d'épouvante immersif plongeant les joueurs dans un ancien hôpital psychiatrique abandonné. Grâce à ses décors détaillés, ses mécanismes modernes et son gameplay évolutif, il s'adresse aussi bien aux débutants qu'aux passionnés d'escape games recherchant une expérience immersive et angoissante.",
      "One Hour a gagné l'award du meilleur gamemaster escape game 2016 et 2017 grâce à l'escape game Lost Asylum.",
      "Récompensé à plusieurs reprises par les TERPECA et sélectionné parmi les meilleurs escape games du monde, Lost Asylum fait partie des références du divertissement immersif à Paris. Accessible de 2 à 5 joueurs, il constitue une activité idéale entre amis, en couple ou dans le cadre d'un team building original."
    ],
    video: 'https://www.youtube.com/embed/t5_YCPjv31M'
  },
  abattoir: {
    notice: [
      "L'âge minimum recommandé pour participer à une session chez One Hour est de 14 ans.",
      'Paiement partagé disponible pour permettre à chaque joueur de régler sa part.'
    ],
    whyTitle: "Pourquoi choisir L'Abattoir ?",
    why: [
      ['Horreur extrême', 'Une pression constante du début à la fin.'],
      ["Présence d'acteurs", 'Vous ne serez jamais totalement seul.'],
      ['Décors de cinéma', 'Un véritable abattoir reconstitué.'],
      ['Adrénaline maximale', "L'une des expériences les plus intenses de Paris."]
    ],
    forTitle: "Êtes-vous fait pour L'Abattoir ?",
    forIntro: 'Cette salle est idéale si :',
    for: [
      "Vous aimez les films d'horreur",
      'Vous aimez être surpris',
      'Vous cherchez des sensations fortes',
      'Vous voulez vivre une expérience immersive',
      'Vous recherchez un escape game vraiment effrayant'
    ],
    awardsTitle: 'Récompenses et reconnaissances',
    awardsIntro: "L'Abattoir a reçu plusieurs distinctions importantes dans le monde de l'escape game.",
    awards: [
      ['Escape Awards 2019', "Meilleur décor d'escape game en Île-de-France."],
      ['TERPECA', "L'Abattoir a été récompensé ou finaliste aux TERPECA à 7 reprises entre 2019 et 2025, dont une 44e place mondiale."],
      ['Best of Morty', '2023 et 2024.'],
      ["Tripadvisor Travelers' Choice", '2022, 2023, 2024 et 2025.'],
      ['Notes de la communauté', <span><a href="https://www.escapegame.fr/paris/one-hour/labattoir/" target="_blank" rel="noopener noreferrer">96% de satisfaction sur EscapeGame.fr</a>, 19/20 sur Le Meilleur Escape Game et <a href="https://www.the-escapers.com/escape-game/paris/one-hour/labattoir" target="_blank" rel="noopener noreferrer">4,7/5 sur The Escapers</a>.</span>]
    ],
    splitTitle: "L'Abattoir : une référence horreur",
    splitText: [
      "Pour un escape game horreur français, être à la fois récompensé pour ses décors et classé au TERPECA plusieurs années de suite est une reconnaissance majeure.",
      "L'expérience mêle tension, comédiens, énigmes intégrées au décor et ambiance oppressante."
    ],
    faqTitle: 'Questions fréquemment posées',
    faq: [
      ["L'Abattoir fait-il vraiment peur ?", "Tout dépend de la sensibilité des gens, mais oui L'Abattoir est construit comme une expérience horreur avec acteur."],
      ['Peut-on jouer à deux ?', 'Oui, aucun souci, le jeu est optimisé pour.'],
      ['Y a-t-il des acteurs ?', "Oui. L'expérience repose en partie sur les interactions avec acteur."],
      ['Faut-il courir ?', "Non. L'expérience est conçue pour rester accessible à tous."],
      ['Y a-t-il du contact physique ?', "Non. Les acteurs n'ont pas vocation à toucher les joueurs."]
    ],
    geoTitle: "L'Abattoir : un escape game horreur incontournable à Paris",
    geo: [
      "Situé dans le 11e arrondissement de Paris, L'Abattoir est un escape game horreur immersif plongeant les joueurs dans un ancien complexe industriel abandonné. Réputée pour son ambiance oppressante, ses décors ultra réalistes et ses interventions d'acteurs, cette aventure est devenue une référence parmi les escape games horreur de Paris.",
      "Accessible de 2 à 5 joueurs, L'Abattoir s'adresse aux amateurs de sensations fortes souhaitant vivre une expérience immersive proche d'un film d'horreur. Entre tension psychologique, adrénaline et énigmes intégrées au décor, chaque minute passée dans l'abattoir est conçue pour marquer les esprits.",
      "Finaliste des TERPECA et régulièrement citée parmi les meilleures expériences immersives de la capitale, L'Abattoir est aujourd'hui l'une des activités les plus recommandées pour les groupes d'amis, les couples amateurs de frissons et les passionnés d'escape games à Paris."
    ],
    video: 'https://www.youtube.com/embed/eRSWjk60Ej8'
  },
  yakuza: {
    notice: [
      "L'âge minimum recommandé pour participer à une session chez One Hour est de 14 ans.",
      'Nous conseillons de faire des équipes de 2 à 5 joueurs. À 6 le jeu sera moins intense et confortable.',
      'Paiement partagé disponible pour permettre à chaque joueur de régler sa part.'
    ],
    whyTitle: 'Pourquoi choisir Mission Yakuza ?',
    why: [
      ['Une véritable enquête criminelle', 'Analysez des preuves comme dans une série policière.'],
      ['Un univers inspiré du Japon', 'Découvrez les codes et secrets du monde des Yakuza.'],
      ['Une immersion dans la police scientifique', 'Laboratoire, indices, interrogatoires et investigations.'],
      ['Une salle riche en réflexion', 'Chaque découverte vous rapproche de la vérité.']
    ],
    forTitle: 'Êtes-vous fait pour Mission Yakuza ?',
    forIntro: 'Cette salle est idéale si :',
    for: [
      'Vous aimez les enquêtes policières',
      'Vous adorez résoudre des mystères',
      'Vous aimez les séries criminelles',
      'Vous recherchez un escape game intelligent',
      "Vous aimez l'univers japonais"
    ],
    awardsTitle: 'Avis presse et blogs sur Mission Yakuza',
    awardsIntro: 'Plusieurs médias spécialisés ont testé Mission Yakuza et saluent son approche enquête, sa cohérence et son gameplay policier.',
    awards: [
      ['Le Meilleur Escape Game - 18,5/20', <a href="https://lemeilleurescapegame.fr/one_hour_voltaire/mission_yakuza" target="_blank" rel="noopener noreferrer">Lire l'article</a>],
      ["Les Potes d'Échappement - 19,25/20", <a href="https://lespotesdechappement.com/mission-yakuza/" target="_blank" rel="noopener noreferrer">Lire l'article</a>],
      ['Les Glandus - 5/5', <a href="https://lesglandus.fr/escapegame/one-hour/mission-yakuza" target="_blank" rel="noopener noreferrer">Lire l'article</a>],
      ['EscapeGame.fr', <a href="https://www.escapegame.fr/paris/one-hour/mission-yakuza/" target="_blank" rel="noopener noreferrer">Lire l'article</a>],
      ["Tripadvisor Travelers' Choice", '2022, 2023, 2024 et 2025.'],
      ['Reconnaissance des joueurs', <span><a href="https://www.the-escapers.com/escape-game/paris/one-hour/mission-yakuza" target="_blank" rel="noopener noreferrer">92% de satisfaction sur The Escapers</a> avec plus de 335 avis joueurs.</span>]
    ],
    splitTitle: 'Une enquête immersive et logique',
    splitText: [
      'Mission Yakuza veut avant tout vous plonger dans une enquête policière réaliste.',
      'Vous serez amenés à manipuler des objets de la police scientifique et à raisonner comme si vous deviez résoudre une véritable enquête policière.',
      'Vos choix seront importants : Mission Yakuza propose 6 fins de jeu différentes suivant vos choix et vos succès.'
    ],
    faqTitle: 'Questions fréquemment posées',
    faq: [
      ['Mission Yakuza fait-elle peur ?', "Non. L'expérience est centrée sur l'enquête et l'investigation."],
      ['Faut-il connaître le Japon ?', 'Pas du tout. Toutes les informations nécessaires sont intégrées au jeu.'],
      ['Peut-on jouer en famille ?', 'Oui. Mission Yakuza est particulièrement appréciée des familles avec adolescents.'],
      ['Est-ce une vraie enquête ?', "Oui. L'expérience repose sur l'analyse d'indices et la résolution d'une affaire criminelle."],
      ['Y a-t-il plusieurs fins ?', 'Oui. Vos décisions pendant l’enquête peuvent influencer la conclusion de votre mission.']
    ],
    geoTitle: 'Mission Yakuza : un escape game enquête unique à Paris',
    geo: [
      "Situé dans le 11e arrondissement de Paris, Mission Yakuza est un escape game d'enquête plongeant les joueurs dans une affaire criminelle inspirée de l'univers des Yakuza japonais.",
      "Les joueurs évoluent dans un véritable laboratoire de police scientifique où ils doivent examiner les indices, identifier les suspects et reconstituer les événements ayant conduit à un assassinat.",
      "Accessible de 2 à 6 joueurs, cette salle est idéale pour les amateurs de séries policières, de culture japonaise et d'énigmes basées sur la logique et l'observation."
    ],
    video: 'https://www.youtube.com/embed/alDcub0Ujl4'
  },
  tombeau: {
    notice: [
      "L'âge minimum recommandé pour participer à une session chez One Hour est de 14 ans.",
      'Nous conseillons de faire des équipes de 2 à 5 joueurs. À 6 le jeu sera moins intense et confortable.',
      'Paiement partagé disponible pour permettre à chaque joueur de régler sa part.'
    ],
    whyTitle: "Pourquoi choisir L'Expédition Maudite ?",
    why: [
      ['Une véritable aventure archéologique', 'Explorez un tombeau oublié rempli de mystères.'],
      ['Énigmes intégrées au décor', 'Chaque élément peut cacher un indice.'],
      ['Immersion cinématographique', 'Décors, lumière et effets spéciaux vous plongent dans une véritable expédition.'],
      ['Accessible à tous', "Débutants comme joueurs expérimentés peuvent profiter pleinement de l'aventure."]
    ],
    forTitle: "Êtes-vous fait pour L'Expédition Maudite ?",
    forIntro: 'Cette salle est idéale si :',
    for: [
      'Vous aimez Indiana Jones',
      'Vous adorez les mystères et les trésors perdus',
      'Vous cherchez une aventure immersive',
      'Vous voulez jouer en famille ou entre amis',
      'Vous souhaitez quelques frissons sans horreur extrême'
    ],
    awardsTitle: "Récompenses de L'Expédition Maudite",
    awardsIntro: "L'Expédition Maudite est aujourd'hui l'une des salles les plus récompensées de One Hour.",
    awards: [
      ['TERPECA', 'Classée dans le Top mondial des escape games en 2022, 2023 et 2024. 71e meilleure salle du monde en 2022.'],
      ['Golden Escape Awards', 'Top 7 mondial en 2023. Top 16 mondial en 2024.'],
      ['Best of Morty', 'Lauréate 2023 et 2024.'],
      ['Escape Game Awards', 'Top 3 Escape Game Awards 2024.'],
      ["Tripadvisor Travelers' Choice", '2022, 2023, 2024 et 2025.'],
      ['Reconnaissance des joueurs', '97% de satisfaction sur Escapegame.fr avec plus de 850 avis joueurs.']
    ],
    splitTitle: "L'Expédition Maudite : une aventure immersive",
    splitText: [
      "Mélangeant exploration, réflexion et immersion, cette aventure séduit aussi bien les familles que les groupes d'amis, les couples et les joueurs débutants.",
      "Grâce à ses décors détaillés et ses effets spéciaux, elle offre une expérience proche d'un film d'aventure grandeur nature.",
      "C'est une excellente alternative pour les joueurs recherchant une expérience immersive sans l'intensité d'un escape game horreur."
    ],
    faqTitle: 'Questions fréquemment posées',
    faq: [
      ["L'Expédition Maudite fait-elle peur ?", "L'expérience contient quelques moments de tension et de surprise mais reste avant tout une aventure immersive."],
      ['Peut-on jouer en famille ?', "Oui. C'est l'une des salles les plus adaptées aux familles et aux groupes mixtes."],
      ['Faut-il être un expert en escape game ?', 'Pas du tout. Les débutants apprécient particulièrement cette aventure et ses mécanismes incroyables.'],
      ['Combien de joueurs peuvent participer ?', 'De 2 à 6 joueurs.'],
      ['Cette salle est-elle adaptée pour une première expérience ?', "Oui. C'est même souvent celle que nous recommandons aux joueurs qui découvrent les escape games."]
    ],
    geoTitle: "L'Expédition Maudite : une aventure immersive à Paris",
    geo: [
      "Située dans le 11e arrondissement de Paris, L'Expédition Maudite est une salle d'escape game inspirée des grandes aventures archéologiques. Les joueurs explorent un tombeau oublié, résolvent des énigmes intégrées au décor et découvrent les secrets d'une expédition disparue.",
      "Finaliste des TERPECA et régulièrement citée parmi les meilleures salles d'aventure de Paris, L'Expédition Maudite constitue une excellente alternative pour les joueurs recherchant une expérience immersive sans l'intensité d'un escape game horreur.",
      "Si vous avez toujours rêvé de vivre votre propre aventure digne des grands films d'exploration et de chasse au trésor, L'Expédition Maudite a été conçue pour vous."
    ],
    video: 'https://www.youtube.com/embed/7FuxM_4Lh8Y'
  },
  vbn: {
    notice: [
      "L'âge minimum recommandé pour participer à une session chez One Hour est de 14 ans.",
      'Nous conseillons de faire des équipes de 2 à 5 joueurs. À 6 le jeu sera moins intense et confortable.',
      'Paiement partagé disponible pour permettre à chaque joueur de régler sa part.'
    ],
    whyTitle: 'Pourquoi choisir Very Bad Night ?',
    why: [
      ['Une aventure totalement déjantée', 'Chaque découverte soulève encore plus de questions.'],
      ['Humour du début à la fin', 'Une salle conçue pour rire autant que réfléchir.'],
      ['Une enquête à rebours', 'Retrouvez les événements de votre soirée.'],
      ['Idéal entre amis', 'Parfait pour anniversaires, EVG, EVJF ou sorties de groupe.']
    ],
    forTitle: 'Êtes-vous fait pour Very Bad Night ?',
    forIntro: 'Cette salle est idéale si :',
    for: [
      'Vous aimez les situations absurdes',
      'Vous cherchez une activité fun entre amis',
      'Vous adorez les films comme Very Bad Trip',
      'Vous aimez les enquêtes originales',
      'Vous voulez rire autant que réfléchir'
    ],
    awardsTitle: 'Récompenses et reconnaissances',
    awardsIntro: 'Very Bad Night a reçu plusieurs distinctions depuis sa création et fait partie des salles régulièrement citées par les blogs spécialisés.',
    awards: [
      ['Award du meilleur scénario escape game 2017'],
      ["Tripadvisor Travelers' Choice", '2022, 2023, 2024 et 2025'],
      ['Les Glandus - 5/5', <a href="https://www.lesglandus.fr/escapegame/one-hour/very-bad-night/" target="_blank" rel="noopener noreferrer">Lire l'article</a>],
      ['Paris City Game', <a href="https://pariscitygame.fr/one-hour-escape-game/" target="_blank" rel="noopener noreferrer">Lire l'article</a>],
      ['EscapeGame.fr - 4,5/5', <a href="https://www.escapegame.fr/paris/one-hour/very-bad-night/" target="_blank" rel="noopener noreferrer">Lire l'article</a>],
      ['The Escapers - 4,4/5', <a href="https://www.the-escapers.com/escape-game/paris/one-hour/very-bad-night" target="_blank" rel="noopener noreferrer">Lire l'article</a>]
    ],
    splitTitle: 'Un escape game en constante évolution',
    splitText: [
      "Very Bad Night, sortie en 2016, est la deuxième salle de One Hour.",
      "Afin de proposer une expérience à la hauteur des escape games nouvelle génération, Very Bad Night a subi de nombreuses évolutions : gameplay, mécanismes inédits, décors, et l'ensemble du jeu a entièrement été repensé en 2021.",
      "Comme toutes nos autres salles, nous l'améliorons au quotidien car nous pensons que l'escape game est un loisir en constante évolution."
    ],
    faqTitle: 'Questions fréquemment posées',
    faq: [
      ['Very Bad Night fait-il peur ?', "Non. C'est la salle la plus légère et la plus humoristique de One Hour."],
      ['Peut-on jouer en famille ?', 'Oui. La salle est adaptée aux familles avec adolescents.'],
      ['Faut-il connaître le film Very Bad Trip ?', "Pas du tout. L'aventure est totalement indépendante."],
      ['Est-ce adapté à une première expérience ?', "Oui. C'est même l'une des meilleures salles pour découvrir les escape games."],
      ['Quelle est la spécificité de Very Bad Night ?', "Very Bad Night est une aventure où l'humour prime sur le stress, remplie de surprises, de happenings et de défis en tout genre."]
    ],
    geoTitle: 'Very Bad Night : un escape game drôle et déjanté à Paris',
    geo: [
      "Situé dans le 11e arrondissement de Paris, Very Bad Night est un escape game humoristique où les joueurs doivent reconstituer les événements d'une soirée totalement incontrôlable.",
      "Mélangeant enquête, humour et situations absurdes, cette aventure se distingue des escape games traditionnels par son ton léger et son scénario original.",
      "Accessible aux débutants comme aux joueurs expérimentés, elle constitue une activité idéale entre amis, en famille, pour un anniversaire ou un EVJF/EVG à Paris."
    ],
    video: 'https://www.youtube.com/embed/YhX07IK3dkk'
  }
}

const dataEn = {
  lostAsylum: {
    ...data.lostAsylum,
    notice: [
      'The recommended minimum age to play a One Hour session is 14. Not recommended for people with epilepsy.',
      'Split payment is available so each player can pay their share.'
    ],
    whyTitle: 'Why choose Lost Asylum?',
    why: [
      ['A highly immersive abandoned psychiatric hospital'],
      ['Progressive gameplay suited to beginners and experienced players'],
      ['No padlock-based mechanisms'],
      ['Actors are part of the experience'],
      ['Several TERPECA selections'],
      ['Playable from 2 to 5 players'],
      ['More than 10 years of continuous improvements']
    ],
    forTitle: 'Who is this room for?',
    forIntro: 'Lost Asylum is ideal if:',
    for: [
      'You enjoy horror movies',
      'You are looking for an immersive escape game',
      'You want to be scared without doing a haunted house',
      'You are a group of 2 to 5 players',
      'You are looking for a first horror escape game in Paris'
    ],
    awardsEyebrow: 'Awards',
    awardsTitle: 'Awards and recognition',
    awardsIntro: 'Lost Asylum has been selected among the best escape games in the world by TERPECA, an international ranking that highlights the best rooms every year.',
    awards: [
      ['TERPECA selection', '2019, 2020, 2021, 2022 and 2024'],
      ["Tripadvisor Travelers' Choice", '2025'],
      ['Best Game Master Award', 'Best Escape Game Game Master in 2016 and 2017 thanks to the experience built around Lost Asylum.'],
      ['Community ratings', <span><a href="https://lemeilleurescapegame.fr/One_Hour_Paris/lost-asylum" target="_blank" rel="noopener noreferrer">19.5/20 on Le Meilleur Escape Game</a> and <a href="https://www.escapegame.fr/paris/one-hour/lost-asylum/" target="_blank" rel="noopener noreferrer">5/5, 94% community score on EscapeGame.fr</a>.</span>]
    ],
    splitTitle: 'An escape game that keeps evolving',
    splitText: [
      'Lost Asylum, a pioneer of horror escape games in Paris and One Hour\'s first room, opened in 2015.',
      'To keep the experience at the level of new-generation escape games, Lost Asylum has evolved many times: gameplay, no-padlock mechanisms, sets and pacing.',
      'The whole adventure was fully reworked in 2021 and is still improved every day by our team.'
    ],
    faqTitle: 'Lost Asylum FAQ',
    faq: [
      ['Is Lost Asylum really scary?', 'Lost Asylum is a horror escape game mixing puzzles, tension and immersion inside an abandoned psychiatric hospital.'],
      ['Can Lost Asylum be played by 2 players?', 'Yes, the room is designed for 2 to 5 players.'],
      ['Are there actors?', 'Yes, some elements of the game may surprise or scare players.'],
      ['Is it suitable for a first escape game?', 'Yes, thanks to its progressive gameplay.'],
      ['How long does the experience last?', 'Allow around 1 hour 30 minutes including the game, debrief and souvenir photo.']
    ],
    geoTitle: 'Lost Asylum: a must-play horror escape game in Paris',
    geo: [
      'Located in the 11th arrondissement of Paris, Lost Asylum is an immersive horror escape game that takes players into an abandoned psychiatric hospital. With detailed sets, modern mechanisms and progressive gameplay, it is suitable for beginners as well as escape game fans looking for an intense, atmospheric experience.',
      'One Hour won the Best Escape Game Game Master award in 2016 and 2017 thanks to Lost Asylum.',
      'Selected several times by TERPECA and ranked among the best escape games in the world, Lost Asylum is one of Paris\'s immersive entertainment references. Playable from 2 to 5 players, it is ideal with friends, as a couple or for an original team building activity.'
    ],
    reserveLabel: 'Book'
  },
  abattoir: {
    ...data.abattoir,
    notice: [
      'The recommended minimum age to play a One Hour session is 14.',
      'Split payment is available so each player can pay their share.'
    ],
    whyTitle: "Why choose L'Abattoir?",
    why: [
      ['Extreme horror', 'Constant pressure from start to finish.'],
      ['Actors are part of the experience', 'You will never be completely alone.'],
      ['Movie-like sets', 'A full slaughterhouse rebuilt for the game.'],
      ['Maximum adrenaline', 'One of the most intense experiences in Paris.']
    ],
    forTitle: "Is L'Abattoir right for you?",
    forIntro: 'This room is ideal if:',
    for: [
      'You enjoy horror movies',
      'You like being surprised',
      'You are looking for strong thrills',
      'You want to experience deep immersion',
      'You are looking for a truly scary escape game'
    ],
    awardsEyebrow: 'Awards',
    awardsTitle: 'Awards and recognition',
    awardsIntro: "L'Abattoir has received several major distinctions in the escape game world.",
    awards: [
      ['Escape Awards 2019', 'Best escape game set in Ile-de-France.'],
      ['TERPECA', "L'Abattoir was awarded or selected as a TERPECA finalist 7 times between 2019 and 2025, including a 44th place worldwide."],
      ['Best of Morty', '2023 and 2024.'],
      ["Tripadvisor Travelers' Choice", '2022, 2023, 2024 and 2025.'],
      ['Community ratings', <span><a href="https://www.escapegame.fr/paris/one-hour/labattoir/" target="_blank" rel="noopener noreferrer">96% satisfaction on EscapeGame.fr</a>, 19/20 on Le Meilleur Escape Game and <a href="https://www.the-escapers.com/escape-game/paris/one-hour/labattoir" target="_blank" rel="noopener noreferrer">4.7/5 on The Escapers</a>.</span>]
    ],
    splitTitle: "L'Abattoir: a horror reference",
    splitText: [
      'For a French horror escape game, being both awarded for its sets and ranked by TERPECA several years in a row is major recognition.',
      'The experience combines tension, actors, puzzles integrated into the scenery and an oppressive atmosphere.'
    ],
    faqTitle: 'Frequently asked questions',
    faq: [
      ["Is L'Abattoir really scary?", "It depends on each player's sensitivity, but yes: L'Abattoir is built as a horror experience with an actor."],
      ['Can it be played by two players?', 'Yes, absolutely. The game is optimized for it.'],
      ['Are there actors?', 'Yes. The experience partly relies on interactions with an actor.'],
      ['Do you have to run?', 'No. The experience is designed to remain accessible to everyone.'],
      ['Is there physical contact?', 'No. The actors are not meant to touch players.']
    ],
    geoTitle: "L'Abattoir: a must-play horror escape game in Paris",
    geo: [
      "Located in the 11th arrondissement of Paris, L'Abattoir is an immersive horror escape game set in an abandoned industrial complex. Known for its oppressive atmosphere, ultra-realistic sets and actor interventions, it has become a reference among horror escape games in Paris.",
      "Playable from 2 to 5 players, L'Abattoir is made for thrill seekers who want an immersive experience close to a horror movie. Psychological tension, adrenaline and puzzles integrated into the set are designed to leave a strong memory.",
      "A TERPECA finalist and regularly mentioned among the capital's best immersive experiences, L'Abattoir is now one of the most recommended activities for groups of friends, horror-loving couples and escape game fans in Paris."
    ],
    reserveLabel: 'Book'
  },
  yakuza: {
    ...data.yakuza,
    notice: [
      'The recommended minimum age to play a One Hour session is 14.',
      'We recommend teams of 2 to 5 players. With 6 players, the game will be less intense and less comfortable.',
      'Split payment is available so each player can pay their share.'
    ],
    whyTitle: 'Why choose Mission Yakuza?',
    why: [
      ['A real criminal investigation', 'Analyze evidence like in a crime series.'],
      ['A world inspired by Japan', 'Discover the codes and secrets of the Yakuza world.'],
      ['Immersion in forensic police work', 'Laboratory, clues, interrogations and investigations.'],
      ['A thinking-focused room', 'Every discovery brings you closer to the truth.']
    ],
    forTitle: 'Is Mission Yakuza right for you?',
    forIntro: 'This room is ideal if:',
    for: [
      'You enjoy police investigations',
      'You love solving mysteries',
      'You enjoy crime series',
      'You are looking for a smart escape game',
      'You like Japanese-inspired universes'
    ],
    awardsEyebrow: 'Awards',
    awardsTitle: 'Press and blog reviews about Mission Yakuza',
    awardsIntro: 'Several specialist media outlets have tested Mission Yakuza and praised its investigation approach, consistency and police-style gameplay.',
    awards: [
      ['Le Meilleur Escape Game - 18.5/20', <a href="https://lemeilleurescapegame.fr/one_hour_voltaire/mission_yakuza" target="_blank" rel="noopener noreferrer">Read the article</a>],
      ["Les Potes d'Echappement - 19.25/20", <a href="https://lespotesdechappement.com/mission-yakuza/" target="_blank" rel="noopener noreferrer">Read the article</a>],
      ['Les Glandus - 5/5', <a href="https://lesglandus.fr/escapegame/one-hour/mission-yakuza" target="_blank" rel="noopener noreferrer">Read the article</a>],
      ['EscapeGame.fr', <a href="https://www.escapegame.fr/paris/one-hour/mission-yakuza/" target="_blank" rel="noopener noreferrer">Read the article</a>],
      ["Tripadvisor Travelers' Choice", '2022, 2023, 2024 and 2025.'],
      ['Player recognition', <span><a href="https://www.the-escapers.com/escape-game/paris/one-hour/mission-yakuza" target="_blank" rel="noopener noreferrer">92% satisfaction on The Escapers</a> with more than 335 player reviews.</span>]
    ],
    splitTitle: 'An immersive and logical investigation',
    splitText: [
      'Mission Yakuza is designed above all to immerse you in a realistic police investigation.',
      'You will handle forensic police objects and think as if you had to solve a real criminal case.',
      'Your choices matter: Mission Yakuza offers 6 different endings depending on your decisions and your success.'
    ],
    faqTitle: 'Frequently asked questions',
    faq: [
      ['Is Mission Yakuza scary?', 'No. The experience focuses on investigation and deduction.'],
      ['Do you need to know Japan?', 'Not at all. All necessary information is included in the game.'],
      ['Can it be played as a family?', 'Yes. Mission Yakuza is especially appreciated by families with teenagers.'],
      ['Is it a real investigation?', 'Yes. The experience is based on analyzing clues and solving a criminal case.'],
      ['Are there several endings?', 'Yes. Your decisions during the investigation can influence the outcome of your mission.']
    ],
    geoTitle: 'Mission Yakuza: a unique investigation escape game in Paris',
    geo: [
      'Located in the 11th arrondissement of Paris, Mission Yakuza is an investigation escape game that immerses players in a criminal case inspired by the Japanese Yakuza universe.',
      'Players move through a real forensic police laboratory where they must examine clues, identify suspects and reconstruct the events leading to a murder.',
      'Playable from 2 to 6 players, this room is ideal for fans of crime series, Japanese culture and puzzles based on logic and observation.'
    ],
    reserveLabel: 'Book'
  },
  tombeau: {
    ...data.tombeau,
    notice: [
      'The recommended minimum age to play a One Hour session is 14.',
      'We recommend teams of 2 to 5 players. With 6 players, the game will be less intense and less comfortable.',
      'Split payment is available so each player can pay their share.'
    ],
    whyTitle: 'Why choose The Cursed Expedition?',
    why: [
      ['A real archaeological adventure', 'Explore a forgotten tomb full of mysteries.'],
      ['Puzzles integrated into the scenery', 'Every element can hide a clue.'],
      ['Cinematic immersion', 'Sets, lighting and special effects plunge you into a real expedition.'],
      ['Accessible to everyone', 'Beginners and experienced players can fully enjoy the adventure.']
    ],
    forTitle: 'Is The Cursed Expedition right for you?',
    forIntro: 'This room is ideal if:',
    for: [
      'You like Indiana Jones',
      'You love mysteries and lost treasures',
      'You are looking for an immersive adventure',
      'You want to play with family or friends',
      'You want a few thrills without extreme horror'
    ],
    awardsEyebrow: 'Awards',
    awardsTitle: 'The Cursed Expedition awards',
    awardsIntro: 'The Cursed Expedition is now one of One Hour\'s most awarded rooms.',
    awards: [
      ['TERPECA', 'Ranked among the world top escape games in 2022, 2023 and 2024. 71st best room in the world in 2022.'],
      ['Golden Escape Awards', 'World top 7 in 2023. World top 16 in 2024.'],
      ['Best of Morty', 'Winner in 2023 and 2024.'],
      ['Escape Game Awards', 'Top 3 Escape Game Awards 2024.'],
      ["Tripadvisor Travelers' Choice", '2022, 2023, 2024 and 2025.'],
      ['Player recognition', '97% satisfaction on Escapegame.fr with more than 850 player reviews.']
    ],
    splitTitle: 'The Cursed Expedition: an immersive adventure',
    splitText: [
      'Mixing exploration, thinking and immersion, this adventure appeals to families, groups of friends, couples and beginners alike.',
      'Thanks to detailed sets and special effects, it offers an experience close to a life-size adventure movie.',
      'It is an excellent alternative for players looking for an immersive experience without the intensity of a horror escape game.'
    ],
    faqTitle: 'Frequently asked questions',
    faq: [
      ['Is The Cursed Expedition scary?', 'The experience includes a few tense and surprising moments, but it remains above all an immersive adventure.'],
      ['Can it be played as a family?', 'Yes. It is one of the rooms most suited to families and mixed groups.'],
      ['Do you need to be an escape game expert?', 'Not at all. Beginners especially enjoy this adventure and its impressive mechanisms.'],
      ['How many players can participate?', 'From 2 to 6 players.'],
      ['Is this room suitable for a first experience?', 'Yes. It is often the room we recommend to people discovering escape games.']
    ],
    geoTitle: 'The Cursed Expedition: an immersive adventure in Paris',
    geo: [
      'Located in the 11th arrondissement of Paris, The Cursed Expedition is an escape game inspired by great archaeological adventures. Players explore a forgotten tomb, solve puzzles integrated into the scenery and uncover the secrets of a vanished expedition.',
      'A TERPECA finalist and regularly mentioned among the best adventure rooms in Paris, The Cursed Expedition is an excellent alternative for players looking for an immersive experience without the intensity of a horror escape game.',
      'If you have always dreamed of living your own exploration and treasure-hunt adventure, The Cursed Expedition was designed for you.'
    ],
    reserveLabel: 'Book'
  },
  vbn: {
    ...data.vbn,
    notice: [
      'The recommended minimum age to play a One Hour session is 14.',
      'We recommend teams of 2 to 5 players. With 6 players, the game will be less intense and less comfortable.',
      'Split payment is available so each player can pay their share.'
    ],
    whyTitle: 'Why choose Very Bad Night?',
    why: [
      ['A completely wild adventure', 'Every discovery raises even more questions.'],
      ['Humor from start to finish', 'A room designed to make you laugh as much as think.'],
      ['A backwards investigation', 'Piece together what happened during your night out.'],
      ['Ideal with friends', 'Perfect for birthdays, bachelor parties, bachelorette parties or group outings.']
    ],
    forTitle: 'Is Very Bad Night right for you?',
    forIntro: 'This room is ideal if:',
    for: [
      'You enjoy absurd situations',
      'You are looking for a fun activity with friends',
      'You like movies such as The Hangover',
      'You enjoy original investigations',
      'You want to laugh as much as think'
    ],
    awardsEyebrow: 'Awards',
    awardsTitle: 'Awards and recognition',
    awardsIntro: 'Very Bad Night has received several distinctions since its creation and is regularly mentioned by specialist blogs.',
    awards: [
      ['Best escape game scenario award 2017'],
      ["Tripadvisor Travelers' Choice", '2022, 2023, 2024 and 2025'],
      ['Les Glandus - 5/5', <a href="https://www.lesglandus.fr/escapegame/one-hour/very-bad-night/" target="_blank" rel="noopener noreferrer">Read the article</a>],
      ['Paris City Game', <a href="https://pariscitygame.fr/one-hour-escape-game/" target="_blank" rel="noopener noreferrer">Read the article</a>],
      ['EscapeGame.fr - 4.5/5', <a href="https://www.escapegame.fr/paris/one-hour/very-bad-night/" target="_blank" rel="noopener noreferrer">Read the article</a>],
      ['The Escapers - 4.4/5', <a href="https://www.the-escapers.com/escape-game/paris/one-hour/very-bad-night" target="_blank" rel="noopener noreferrer">Read the article</a>]
    ],
    splitTitle: 'An escape game that keeps evolving',
    splitText: [
      'Very Bad Night, opened in 2016, is One Hour\'s second room.',
      'To keep the experience at the level of new-generation escape games, Very Bad Night has evolved many times: gameplay, original mechanisms, sets, and the whole game was fully reworked in 2021.',
      'Like all our other rooms, we improve it every day because we believe escape games are a constantly evolving form of entertainment.'
    ],
    faqTitle: 'Frequently asked questions',
    faq: [
      ['Is Very Bad Night scary?', 'No. It is One Hour\'s lightest and most humorous room.'],
      ['Can it be played as a family?', 'Yes. The room is suitable for families with teenagers.'],
      ['Do you need to know The Hangover movie?', 'Not at all. The adventure is completely independent.'],
      ['Is it suitable for a first experience?', 'Yes. It is even one of the best rooms to discover escape games.'],
      ['What makes Very Bad Night special?', 'Very Bad Night is an adventure where humor matters more than stress, full of surprises, happenings and challenges of all kinds.']
    ],
    geoTitle: 'Very Bad Night: a funny and wild escape game in Paris',
    geo: [
      'Located in the 11th arrondissement of Paris, Very Bad Night is a humorous escape game where players must reconstruct the events of a completely out-of-control night.',
      'Mixing investigation, humor and absurd situations, this adventure stands apart from traditional escape games with its light tone and original scenario.',
      'Accessible to beginners and experienced players alike, it is an ideal activity with friends, family, for a birthday or for a bachelor/bachelorette party in Paris.'
    ],
    reserveLabel: 'Book'
  }
}

export const getRoomSeoContent = (room, lang) => {
  const localizedData = lang === 'en' ? dataEn : data
  return localizedData[room]
}

const RoomSeoSection = ({ room, lang }) => {
  const content = getRoomSeoContent(room, lang)
  if (!content) return null

  return (
    <div className="room-seo">
      <div className="room-seo-booking-notice">
        {content.notice.map((line) => <p key={line}>{line}</p>)}
      </div>

      <section className="room-seo-two-cols">
        <div>
          <h2>{content.whyTitle}</h2>
          <ul className="room-seo-feature-list">
            {content.why.map((item) => (
              <li key={item[0]}>
                <strong>{item[0]}</strong>
                {item[1] ? <span>{item[1]}</span> : null}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2>{content.forTitle}</h2>
          <p>{content.forIntro}</p>
          <ul className="room-seo-check-list">
            {content.for.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </div>
      </section>

      <ThemeCustomerReviews theme={customerReviewThemeByRoom[room]} lang={lang} />

      <section className="room-seo-awards">
        <span>{content.awardsEyebrow || 'Récompenses'}</span>
        <h2>{content.awardsTitle}</h2>
        <p>{content.awardsIntro}</p>
        <div className="room-seo-awards-grid">
          {content.awards.map((item) => {
            const logo = getAwardLogo(item[0])

            return (
              <article className={logo ? 'room-seo-award-card--with-logo' : ''} key={item[0]}>
                {logo ? (
                  <img
                    className={`room-seo-award-logo ${logo.className}`}
                    src={logo.image}
                    alt={logo.label}
                  />
                ) : null}
                <div>
                  <h3>{item[0]}</h3>
                  {item[1] ? <p>{item[1]}</p> : null}
                </div>
              </article>
            )
          })}
        </div>
      </section>

      <section className="room-seo-purple">
        <div>
          <h2>{content.splitTitle}</h2>
          {content.splitText.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          <a href="#booking" className="room-seo-book-button">{content.reserveLabel || 'Réserver'}</a>
        </div>
        <div>
          <h2>{content.faqTitle}</h2>
          <div className="room-seo-faq">
            {content.faq.map((item) => (
              <details key={item[0]}>
                <summary>{item[0]}</summary>
                <p>{item[1]}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <section className="room-seo-geo">
        <div>
          <h2>{content.geoTitle}</h2>
          {content.geo.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </div>
        <LiteYouTubeEmbed
          videoId={getYouTubeEmbedId(content.video)}
          title={content.geoTitle}
          className="room-seo-video"
          style={{ margin: 0, maxWidth: 'none', width: '100%' }}
        />
      </section>
    </div>
  )
}

export default RoomSeoSection



// WEBPACK FOOTER //
// ./src/components/RoomSeoSection.js